import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Kombinuje Tailwind triedy a odstraňuje duplicity.
 * Používame ju naprieč shadcn/ui komponentmi.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
